/**
 * Learners who need attention, ranked, each with a one-line recommended action
 * and the specific gap. Click to open the full learner profile.
 */

import { ChevronRight, AlertTriangle } from 'lucide-react';
import type { ClassRoster, Learner } from './mockData';
import { needsIntervention, studentActions } from './mockData';
import { Panel, Donut } from './charts';

export function AttentionList({ roster, onSelectLearner }: { roster: ClassRoster; onSelectLearner: (l: Learner) => void }) {
  const flagged = roster.learners
    .filter(needsIntervention)
    .sort((a, b) => a.overallMasteryPercent - b.overallMasteryPercent);

  return (
    <Panel
      title="Needs attention"
      sub={`${flagged.length} learners flagged by mastery, misconceptions or engagement`}
      right={<AlertTriangle className="h-4 w-4 text-[#CB5B6B]" />}
    >
      {flagged.length === 0 ? (
        <p className="text-[13px] text-[#8A8593]">No learners are flagged. The whole class is on track.</p>
      ) : (
        <div className="flex flex-col gap-2">
          {flagged.map((l) => {
            const top = studentActions(l, roster)[0];
            return (
              <button key={l.id} onClick={() => onSelectLearner(l)}
                className="group flex items-center gap-3 rounded-xl border border-black/[0.07] bg-black/[0.015] p-3 text-left transition-colors hover:border-black/15 hover:bg-black/[0.03] dark:border-white/[0.08] dark:bg-white/[0.02] dark:hover:bg-white/[0.05]">
                <Donut percent={l.overallMasteryPercent} size={46}
                  color={l.overallMasteryPercent >= 55 ? '#C99A3B' : '#CB5B6B'}
                  label={<span className="text-[12px]">{l.overallMasteryPercent}</span>} />
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="text-[13.5px] font-semibold">{l.firstName}</span>
                    <span className="text-[11px] text-[#8A8593]">Roll {l.rollNo}</span>
                  </div>
                  <p className="mt-0.5 truncate text-[12px] text-[#56505F] dark:text-[#B2B0C0]">
                    {top ? top.title : 'Review recent attempts'}
                  </p>
                </div>
                <ChevronRight className="h-4 w-4 shrink-0 text-[#8A8593] transition-transform group-hover:translate-x-0.5" />
              </button>
            );
          })}
        </div>
      )}
    </Panel>
  );
}
